import { ChangeDetectorRef, Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { DialogService } from 'src/app/core/api/dialog/dialog.service';

/**
 * アラート情報
 */
export interface AcuteChangeVital {
  key: string;
  icon: string;
  shape: string;
  state: string;
}

export interface AlterInfo {
  /**
   * 発生日時
   */
  time: string;
  /**
   * アイコン
   */
  icon: string;
  /**
   * テキスト
   */
  text: string;
  /**
   * サブテキスト
   */
  subText: string;
  /**
   * 氏名
   */
  name: string;
  /**
   * 病室
   */
  room: string;
  /**
   * 形状（circle, triangle, square）
   */
  shape?: string;
  /**
   * 状態（green, yellow, red）
   */
  state?: string;
  /**
   * 急変リスクのバイタルリスト（heart, temp, oxygen）
   */
  acuteChangeVitals?: AcuteChangeVital[];
  /**
   * アラート履歴ID（API削除用）
   */
  alertHistoryId?: number;
  /**
   * 患者ID（API削除用）
   */
  patientId?: number;
}

export interface AlterIconItem {
  iconPath: string;
  iconName: string;
}

@Component({
  selector: 'app-alert-card',
  templateUrl: './alert-card.component.html',
  styleUrls: ['./alert-card.component.css']
})
export class AlertCardComponent implements OnInit {
  @Input()
  infos: AlterInfo[] = [];
  
  @Output()
  onRemove = new EventEmitter<{ alertHistoryId?: number; patientId?: number }>();

  iconItems: AlterIconItem[] = [
    {
      iconPath: 'assets/images/icon/close.svg',
      iconName: 'close-icon'
    },
    {
      iconPath: 'assets/images/icon/time-icon.svg',
      iconName: 'time-icon'
    },
    {
      iconPath: 'assets/images/icon/blood-pressure.svg',
      iconName: 'blood-pressure-icon'
    },
    {
      iconPath: 'assets/images/icon/breath.svg',
      iconName: 'breath-icon'
    },
    {
      iconPath: 'assets/images/icon/heart-rate.svg',
      iconName: 'heart-rate-icon'
    },
    {
      iconPath: 'assets/images/icon/oxygen.svg',
      iconName: 'oxygen-icon'
    },
    {
      iconPath: 'assets/images/icon/sleep.svg',
      iconName: 'sleep-icon'
    },
    {
      iconPath: 'assets/images/icon/step.svg',
      iconName: 'step-icon'
    },
    {
      iconPath: 'assets/images/icon/temperature.svg',
      iconName: 'temperature-icon'
    },
    {
      iconPath: 'assets/images/icon/delirium/alert.svg',
      iconName: 'alert-icon'
    },
  ];

  // ダイアログメッセージ
  options: any = {
    title: '解除確認',
    message: '',
    cancelText: 'キャンセル',
    confirmText: '確認する',
  };

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private dialogService: DialogService,
    private _cdr: ChangeDetectorRef,
  ) { 
    // カスタムのsvgファイルをmat-iconとして使うため
    for (var iconItem of this.iconItems) {
      this.matIconRegistry.addSvgIcon(
        iconItem.iconName,
        this.domSanitizer.bypassSecurityTrustResourceUrl(iconItem.iconPath)
      );
    }
  }

  ngOnInit(): void {
    
  }

  isOdd(index: number): boolean {
    return index % 2 === 0;
  }

  /**
   * アイコンの背景色クラスを取得
   */
  getIconBackgroundClass(icon: string): string {
    if (icon === 'heart-rate-icon') {
      return 'icon-bg-heart';
    } else if (icon === 'temperature-icon') {
      return 'icon-bg-temp';
    } else if (icon === 'oxygen-icon') {
      return 'icon-bg-oxygen';
    } else if (icon === 'step-icon') {
      return 'icon-bg-step';
    } else if (icon === 'sleep-icon') {
      return 'icon-bg-sleep';
    } else if (icon === 'alert-icon') {
      return 'icon-bg-alert';
    }
    return 'icon-bg-default';
  }

  /**
   * バイタルのテキストを取得
   */
  getVitalText(key: string): string {
    if (key === 'heart') {
      return '心拍数';
    } else if (key === 'temp') {
      return '体温';
    } else if (key === 'oxygen') {
      return '酸素飽和度';
    }
    return '';
  }

  /**
   * 閉じるボタンを押す
   */
  close(info: AlterInfo): void {
    this.options.message = `${info.name}様
のアラートを本当に
解除しますか？
`;
    this.dialogService.open(this.options, true);
    this.dialogService.confirmed().subscribe(confirmed => {
      if (confirmed) {
        // 親コンポーネントに削除イベントを通知
        this.onRemove.emit({
          alertHistoryId: info.alertHistoryId,
          patientId: info.patientId
        });
        // ローカルからも削除（API成功後に親コンポーネントで再取得する場合は不要）
        this.infos = this.infos.filter(item => item !== info);
        // UI更新を通知する
        this._cdr.detectChanges();
      }
    });
  }

}
